export default __webpack_public_path__ + "static/media/directory-company.ec0c1e7a.svg";